import { cn } from '@/lib/utils'

export function PageHeader({
  title,
  description,
  label,
  action,
  className,
}: {
  title: string
  description?: string
  /** Uppercase section label above title */
  label?: string
  action?: React.ReactNode
  className?: string
}) {
  return (
    <header
      className={cn('flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between', className)}
    >
      <div className="space-y-2">
        {label && (
          <p className="font-sans text-label uppercase tracking-[0.12em] text-muted-foreground">
            {label}
          </p>
        )}
        <h1 className="font-serif text-title text-ink">{title}</h1>
        {description && (
          <p className="max-w-2xl font-sans text-sm leading-relaxed text-muted-foreground">
            {description}
          </p>
        )}
      </div>
      {action && <div className="flex shrink-0 items-center gap-2">{action}</div>}
    </header>
  )
}

export function PageShell({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <div className={cn('space-y-8', className)}>{children}</div>
}
